export default __webpack_public_path__ + "static/hero_right-4aeb01c6b3e6778142a52c126cb15d11.png";